// extracted by mini-css-extract-plugin
module.exports = {"grouping_count":"index_grouping_count_3tY3r","right":"index_right_3KQNl"};